import React, { type ReactNode } from 'react';
import notification from 'antd/lib/notification';

type ErrorHandlerProps = {
  children: ReactNode;
};

export default class ErrorHandler extends React.Component<ErrorHandlerProps> {
  componentDidCatch(error: Error) {
    notification.error({
      message: 'Ошибка',
      description: error.message
    });
  }

  render() {
    return this.props.children;
  }
}
